'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Breadcrumb = require('./Breadcrumb');

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

var _ChildList = require('./ChildList');

var _ChildList2 = _interopRequireDefault(_ChildList);

var _fetchTaxonomy = require('../helpers/fetchTaxonomy');

var _fetchTaxonomy2 = _interopRequireDefault(_fetchTaxonomy);

var _fetchSpotReportViews = require('../helpers/fetchSpotReportViews');

var _fetchSpotReportViews2 = _interopRequireDefault(_fetchSpotReportViews);

var _utils = require('./utils');

var _navigationSettingsPropType = require('../PropTypes/navigationSettingsPropType');

var _navigationSettingsPropType2 = _interopRequireDefault(_navigationSettingsPropType);

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

var _taxonomyStatePropType = require('../PropTypes/taxonomyStatePropType');

var _taxonomyStatePropType2 = _interopRequireDefault(_taxonomyStatePropType);

var _locationStore = require('./utils/locationStore');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaxonomyNavigator = function (_Component) {
  (0, _inherits3.default)(TaxonomyNavigator, _Component);

  function TaxonomyNavigator() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TaxonomyNavigator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TaxonomyNavigator.__proto__ || (0, _getPrototypeOf2.default)(TaxonomyNavigator)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      var _this$props = _this.props,
          navigationSettings = _this$props.navigationSettings,
          savedLocationType = _this$props.savedLocationType;

      var activeNodeId = _this.props.menuState.taxonomy.activeNode._id;
      if (!activeNodeId) {
        var savedLocation = (0, _locationStore.loadSavedLocation)(navigationSettings, savedLocationType);
        _this.setActiveNodeTaxonomy(savedLocation || _constants.EARTH_TAXONOMY_ID, savedLocation ? 1 : 0);
      }
    }, _this.setActiveNodeTaxonomy = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(taxonomyId, maxDepth) {
        var _this$props2, taxonomyType, hierarchy, taxonomy, inLength, contains, listType, children, spotIds, _ref3, data, subregions;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this$props2 = _this.props, taxonomyType = _this$props2.taxonomyType, hierarchy = _this$props2.hierarchy;

                _this.props.setMenuState({ loading: true, error: false });
                _context.next = 5;
                return (0, _fetchTaxonomy2.default)(taxonomyId, maxDepth, _this.props.serviceConfig);

              case 5:
                taxonomy = _context.sent;
                inLength = hierarchy.length - 1;
                contains = taxonomy.contains.filter(function (item) {
                  return (item.type === 'geoname' || item.type === taxonomyType) && (item.type === taxonomyType || item.hasSpots) && (taxonomy.in.length >= inLength || item.depth === 0);
                });
                listType = (0, _utils.getListType)(contains, taxonomyType);
                children = void 0;

                if (!(listType === 'spots')) {
                  _context.next = 19;
                  break;
                }

                spotIds = contains.filter(function (item) {
                  return item.type === 'spot';
                }).map(function (item) {
                  return item.spot;
                });
                _context.next = 14;
                return (0, _fetchSpotReportViews2.default)(spotIds, _this.props.serviceConfig);

              case 14:
                _ref3 = _context.sent;
                data = _ref3.data;

                children = (0, _utils.groupItems)(contains, data);
                _context.next = 20;
                break;

              case 19:
                if (listType === 'subregions') {
                  subregions = contains.filter(function (item) {
                    return item.type === 'subregion';
                  });

                  children = (0, _utils.alphabetizeItems)(subregions);
                } else {
                  children = (0, _utils.alphabetizeItems)(contains);
                }

              case 20:
                _this.props.setMenuState({
                  taxonomyId: taxonomyId,
                  loading: false,
                  error: false,
                  taxonomy: {
                    listType: listType,
                    parents: taxonomy.in.filter(function (item) {
                      return item.type === 'geoname';
                    }),
                    activeNode: {
                      name: taxonomy.name,
                      _id: taxonomy._id,
                      type: taxonomy.type,
                      taxonomyId: taxonomy.taxonomyId,
                      links: taxonomy.associated.links
                    },
                    children: children
                  }
                });
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](0);

                _this.props.setMenuState({ error: true });

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 23]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.updateActiveNodeTaxonomy = function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(taxonomyId) {
        var _this$props3, loggedIn, navigationSettings, savedLocationType, serviceConfig, hierarchy, inLength, depth;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props3 = _this.props, loggedIn = _this$props3.loggedIn, navigationSettings = _this$props3.navigationSettings, savedLocationType = _this$props3.savedLocationType, serviceConfig = _this$props3.serviceConfig, hierarchy = _this$props3.hierarchy;
                // No need to await saveLocation. If it errors we can ignore it and try again next time.

                (0, _locationStore.saveLocation)(taxonomyId, savedLocationType, loggedIn, navigationSettings, serviceConfig);
                inLength = hierarchy.length - 1;
                depth = _this.taxonomyDepth(taxonomyId) < inLength ? 0 : 1;
                _context2.next = 6;
                return _this.setActiveNodeTaxonomy(taxonomyId, depth);

              case 6:
                _this.props.scrollMenuToTop();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }(), _this.taxonomyDepth = function (taxonomyId) {
      var _this$props$menuState = _this.props.menuState.taxonomy,
          parents = _this$props$menuState.parents,
          activeNode = _this$props$menuState.activeNode;

      if (taxonomyId === activeNode._id) return parents.length;

      var parentsIndex = parents.findIndex(function (_ref5) {
        var _id = _ref5._id;
        return _id === taxonomyId;
      });
      if (parentsIndex > -1) return parentsIndex;
      return parents.length + 1;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TaxonomyNavigator, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$menuState = this.props.menuState,
          loading = _props$menuState.loading,
          error = _props$menuState.error,
          taxonomy = _props$menuState.taxonomy;
      var parents = taxonomy.parents,
          activeNode = taxonomy.activeNode,
          children = taxonomy.children,
          listType = taxonomy.listType;
      var _props = this.props,
          hierarchy = _props.hierarchy,
          _onClickLink = _props.onClickLink;


      return _react2.default.createElement(
        'div',
        { className: 'quiver-taxonomy-navigator' },
        _react2.default.createElement(_Breadcrumb2.default, {
          nodes: [].concat((0, _toConsumableArray3.default)(parents), [activeNode]),
          nodesPlaceholder: hierarchy,
          listType: listType,
          onClickNode: this.updateActiveNodeTaxonomy,
          onClickLink: function onClickLink(properties, closeMobileMenu) {
            return _onClickLink((0, _extends3.default)({}, properties, {
              locationCategory: 'Taxonomy',
              currentTaxonomyLevel: parents.length
            }), closeMobileMenu);
          }
        }),
        _react2.default.createElement(_Header2.default, {
          listType: listType,
          activeNode: activeNode,
          label: hierarchy[parents.length + 1],
          onClickChange: function onClickChange() {
            return _this3.updateActiveNodeTaxonomy(_constants.EARTH_TAXONOMY_ID);
          },
          onClickLink: function onClickLink(properties, closeMobileMenu) {
            return _onClickLink((0, _extends3.default)({}, properties, {
              locationCategory: 'Taxonomy',
              currentTaxonomyLevel: parents.length
            }), closeMobileMenu);
          }
        }),
        _react2.default.createElement(_ChildList2.default, {
          listType: listType,
          nodes: children,
          loading: loading,
          error: error,
          onClickNode: this.updateActiveNodeTaxonomy,
          onClickLink: function onClickLink(properties, closeMobileMenu) {
            return _onClickLink((0, _extends3.default)({}, properties, {
              locationCategory: 'Taxonomy',
              currentTaxonomyLevel: parents.length
            }), closeMobileMenu);
          }
        })
      );
    }
  }]);
  return TaxonomyNavigator;
}(_react.Component);

TaxonomyNavigator.propTypes = {
  hierarchy: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  savedLocationType: _propTypes2.default.string.isRequired,
  loggedIn: _propTypes2.default.bool,
  navigationSettings: _navigationSettingsPropType2.default,
  serviceConfig: _serviceConfigurationPropType2.default,
  setMenuState: _propTypes2.default.func.isRequired,
  menuState: _taxonomyStatePropType2.default,
  taxonomyType: _propTypes2.default.string,
  scrollMenuToTop: _propTypes2.default.func,
  onClickLink: _propTypes2.default.func
};
TaxonomyNavigator.defaultProps = {
  loggedIn: false,
  taxonomyType: 'spot',
  onClickLink: null,
  scrollMenuToTop: null
};
exports.default = TaxonomyNavigator;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/TaxonomyNavigator.js
// module id = 341
// module chunks = 0